<script>
    import DropdownArrow from "./DropdownArrow.svelte";

    export let title;
    export let style = '';
    export let data = [];

    let isExpanded = true;

    const toggleExpand = () => isExpanded = !isExpanded;

</script>

<table class="table one-px-table-border" {style}>
  <colgroup>
    <col span="1" style="width: 30%;" />
    <col span="1" style="width: 70%;" />
  </colgroup>
  <thead class="thead-light" on:click={toggleExpand}>
    <tr>
      <th colspan="2">
        <div class="th-content">
          {title}
          <DropdownArrow rotate={isExpanded ? 0 : 270} />
        </div>
      </th>
    </tr>
  </thead>

  {#if isExpanded}
    <tbody>
      {#each data as row}
        {#if row.attachment}
          <tr>
            <th>{row.label}</th>
            <td>
              {#each row.value as attachment}
                <a
                  download={attachment.file_name}
                  href={attachment.location}
                  target="_blank" rel="noopener noreferrer">{attachment.file_name}</a
                ><br />
              {/each}
            </td>
          </tr>
        {:else}
          <tr>
            <th>{row.label}</th>
            <td>{@html row.value}</td>
          </tr>
        {/if}
      {/each}
    </tbody>
  {/if}
</table>

<style>
  .thead-light th {
    position: relative;
    background: #e9ecef;
  }

  .th-content {
    display: flex;
    align-items: center;
  }

  .one-px-table-border {
    border: 1px solid #bbb;
  }
</style>
